import { Typography } from '@mui/material';

import { type TopicLinkProps, useTopicLink } from './useTopicLink';

type Props = TopicLinkProps;

export function TopicLink(props: Props) {
  const hook = useTopicLink(props);

  if (!hook.displayText) {
    return null;
  }

  const rootElement = props.href ? 'a' : hook.isClickable ? 'button' : 'span';

  return (
    <Typography
      component={rootElement}
      variant={hook.variant}
      noWrap={props.noWrap}
      data-testid={props['data-testid']}
      href={props.href}
      onClick={hook.isClickable ? hook.handleClick : undefined}
      sx={(theme) => ({
        display: 'inline',
        textDecoration: hook.underline === 'always' ? 'underline' : 'none',
        color: props.color ?? theme.palette.text.primary,
        background: 'none',
        border: 'none',
        p: 0,
        m: 0,
        font: 'inherit',
        textAlign: 'inherit',
        cursor: hook.isClickable ? 'pointer' : 'inherit',
        transition: theme.transitions.create(['color'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(hook.isClickable && {
          '&:hover': {
            textDecoration: hook.underline !== 'none' ? 'underline' : 'none',
            color: props.color ?? theme.palette.primary.main,
          },
          '&:focus-visible': {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: 2,
            borderRadius: theme.shape.borderRadius,
          },
        }),
      })}
    >
      {hook.displayText}
    </Typography>
  );
}

export type { TopicLinkProps };
